export default "__VITE_ASSET__tbyoaOJk__"